import { Box, Typography } from "@mui/material";
import { useResolutionsContext } from "../hooks/useResolutionsContext";

//This component is responsible for displaying the instructions title for a resolution event.
export default function InstructionsTitle() {
    const { staticText } = useResolutionsContext();
    return (
        <Typography variant="h6" component="div">
            <Box sx={{ fontWeight: 'bold' }}>{staticText?.InstructionsTitle}</Box>
        </Typography>
    );
}